<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1330px"
      unit="资源档案"
      edit-title
      id-key="RecordId"
      :data="data"
      :get-data-func="api.info"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      close-on-saved
      form-label-width="85px"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="资源标题" prop="InfoTitle">
              <el-input v-model="data.InfoTitle" placeholder="请输入资源标题" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="资源类别" prop="InfotypeId">
              <el-select v-model="data.InfotypeId" placeholder="请选择资源类别" clearable>
                <el-option v-for="item in list" :key="item.RecordId" :value="item.RecordId" :label="item.TypeName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
         
         
          <el-col :span="24">
            <el-form-item :label="isMB?'':'资源内容'" :label-width="isMB?'0':''" prop="InfoContent">
              <el-divider v-if="isMB">资源内容</el-divider>
              <editor ref="editor" v-model="data.InfoContent"></editor>
              <el-input v-model="data.InfoContent" v-show="false"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="资源简介" prop="InfoBrief">
              <el-input v-model="data.InfoBrief" type="textarea" rows="3" placeholder="请输入资源简介" clearable></el-input>
            </el-form-item>
          </el-col>
         
          <el-col :span="24">
            <el-form-item :label="isMB?'':'缩略图'" :label-width="isMB?'0':''" prop="PhotoAddress">
              <el-divider v-if="isMB">缩略图</el-divider>
              <single-pic-upload
                v-model="data.PhotoAddress"
                type="PhotoAddress"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
              <span style="color: red">最佳宽高比例1：1</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:6">
            <el-form-item label="发布时间" prop="ReleaseTime">
              <el-date-picker
                v-model.trim="data.ReleaseTime"
                placeholder="请选择发布时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%;"
                type="datetime"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="是否置顶" prop="IfTop">
              <el-radio-group v-model="data.IfTop">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
         
        
        </el-row>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="toSave(0)">保 存</el-button>
        <el-button type="success" @click="toSave(1)" v-if="data.State==0||data.State==3">提 交</el-button>
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>

import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";
import editor from '@/components/common/editor.vue';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
    editor,
  },
  computed: {
    host() {
      return window.location.origin;
    }
  },
  data() {
    return {
      data: {
        RecordId: 0,
        OrderId: 0,
        InfoTitle:"",
        InfotypeId: null,
      
        InfoContent: "",
      
        InfoBrief: "",
        IfTop:0,
        PhotoAddress: "",
        ReleaseTime: "",
      
        State: 0,
      },
      fl: [],
      list: [],
      saveState: 0,
      headers: { Authorization: "" },
      api: require("@/api/resources/detail").default,
      api2: require("@/api/resources/type").default,
      isMB: this.$store.state.isMB,
      rules: {
        InfoTitle:[{ required: true, message: "资源标题不能为空" }],
        // InfoContent: [{ required: true, message: "文章内容不能为空" }],
        PhotoAddress: [{ required: true, message: "缩略图不能为空" }],
        InfotypeId: [{ required: true, message: "资源类别不能为空" }],
        ReleaseTime: [{ required: true, message: "发布日期不能为空" }],
      
      },
      uploadUrl:"/api/Common/UploadPicture",
    };
  },
  methods: {
    onCreateOpened(data) {
     
        this.data.ReleaseTime = this.$commonJs.getNowDatetimeString();
      this.getOption();
      this.api.getMaxOrderId().then(res => {
        if(res.Code==0) this.data.OrderId = res.Data;
      })
    },
    onEditOpened(data) {
      this.getOption();
     // if(data.InfoAttach) this.fl.push({ name: "附件." + data.InfoAttach.split(".")[1], url: '/api' + data.InfoAttach, url2: data.InfoAttach })
    },
    getOption() {
      this.loading(true);
      this.api2.list({State:1}).then(res => {
        this.loading(false);
        if(res.Code==0) {
          this.list = res.Data;
        }
      })
    },
    beforeFileUpload(file) {
    //  var limit = this.$store.state.user.attSize;
      this.headers.Authorization = "Bearer " + this.$commonJs.getCookie("token");
   //   const result = file.size/1024/1024 <= limit || limit == 0;
   //   if(!result) {
   //     this.$message.error("附件大小不能超过" + limit + "M");
   //   }
      return result;
    },
    onSuccess(res,file) {
    /*  if(res.Code==0) {
        this.fl.push({ name: "附件." + file.name.split(".")[1], url: "/api" + res.Data, url2: res.Data })
      } else {
        this.$message.error(res.Msg);
      }*/
    },
   /* dlfile(file) {
      const elink = document.createElement("a");
      elink.download = file.name;
      elink.style.display = "none";
      elink.target = "_blank";
      elink.href = this.host + file.url;
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },*/
    onExceed() {
   //   this.$message.error("超过上传数量限制");
    },
   /* attachRemove(file) {
      this.fl.forEach((e,i) => {
        if(e.url == file.url) {
          this.fl.splice(i,1);
          return;
        }
      })
    },*/
    toSave(t) {
      this.saveState = t;
      this.save();
    },
    onBeforeSave() {
    /*  if(!this.data.InfoLink&&!this.data.InfoContent) {
        this.$message.warning('外链地址、文章内容二者填一');
        return false;
      }
      if(this.fl.length) this.data.InfoAttach = this.fl[0].url2;
      else this.data.InfoAttach = "";
      this.data.InfoContentText = this.$refs.editor.getPlainText();*/
      if(this.saveState == 1) {
        this.loading(true);
        this.api.submit(this.data).then(res => {
          this.loading(false);
          if(res.Code==0) {
            this.$message.success(res.Msg);
            this.$emit("close-saved");
            this.close(true);
          } else {
            this.$message.error(res.Msg);
          }
        })
        return false;
      }
    },
    getIntro() {
      this.data.InfoBrief = this.$refs.editor.getPlainText();
    },
    // checkInt(name) {
    //   if(!(this.data[name] >= 0)) {
    //     this.data[name] = 0;
    //   } else if(this.data[name] %1 != 0) {
    //     this.data[name] = Math.floor(this.data[name]);
    //   }
    // },
    onClosed() {
      this.list = [];
      this.fl = [];
    },
  }
};
</script>
<style lang="scss" scoped>
.file-text{
  .el-form-item__label {
    line-height: 28px;
  }
}
</style>